var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 27296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 27293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 27297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 31025",
    d: "M21.8001 20.8999L16.0901 15.1889C17.4237 13.618 18.0982 11.5922 17.9723 9.53541C17.8464 7.4786 16.93 5.55017 15.4147 4.15364C13.8994 2.7571 11.9028 2.00069 9.84257 2.04267C7.78234 2.08466 5.81817 2.92179 4.36107 4.37889C2.90396 5.836 2.06684 7.80016 2.02485 9.86039C1.98287 11.9206 2.73928 13.9173 4.13581 15.4325C5.53235 16.9478 7.46078 17.8642 9.51759 17.9901C11.5744 18.116 13.6002 17.4416 15.1711 16.1079L20.8811 21.8179C21.0028 21.9398 21.168 22.0083 21.3402 22.0084C21.5125 22.0085 21.6777 21.9401 21.7996 21.8184C21.9215 21.6967 21.99 21.5315 21.9901 21.3593C21.9902 21.187 21.9218 21.0218 21.8001 20.8999ZM3.30009 9.99991C3.30009 8.67477 3.69303 7.3794 4.42924 6.27759C5.16544 5.17578 6.21184 4.31702 7.43611 3.80992C8.66037 3.30281 10.0075 3.17013 11.3072 3.42865C12.6069 3.68717 13.8007 4.32528 14.7377 5.26229C15.6747 6.1993 16.3128 7.39313 16.5713 8.6928C16.8299 9.99248 16.6972 11.3396 16.1901 12.5639C15.683 13.7882 14.8242 14.8345 13.7224 15.5708C12.6206 16.307 11.3252 16.6999 10.0001 16.6999C8.22379 16.6978 6.52084 15.9912 5.26481 14.7352C4.00877 13.4792 3.3022 11.7762 3.30009 9.99991Z",
    fill: "#242424"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a345206f40f5ef7b54dad17b26a1337c.svg";
export { ForwardRef as ReactComponent };